import { Link } from 'react-router-dom';
import { LISTURL } from '../config';

const NotFound = (): JSX.Element => {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center">
      <img
        src="https://assets.onistudio.net/notfound.png"
        alt="Not Found"
        className="block w-full h-auto max-w-xl"
      />
      <div className="max-w-lg">
        <Link
          to={LISTURL.general}
          className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Trang chủ
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
